import { Component } from '@angular/core';
import { BreadcrumbService } from "@shared/services/breadcrumbs.service";
import { BreadcrumbElectionTypes } from "@shared/components/breadcrumbs/breadcrumb.model";

@Component({
  selector: 'valg-dk-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent {
  shortElectionTitle: string | undefined;
  longElectionTitle: string | undefined;

  constructor(breadCrumbService: BreadcrumbService) {
    breadCrumbService.breadcrumbs$.subscribe(result => {
      const electionItem = result.find(x => BreadcrumbElectionTypes.includes(x.type));
      this.shortElectionTitle = electionItem?.label;
      this.longElectionTitle = electionItem?.longLabel;
    });
  }
}
